// A curated set for the map's History & Culture layer — the historic core plus
// the districts around San Juan. Coordinates mark public places; story copy is
// intentionally concise and bilingual. `artPotential` notes where public art
// could live on or near the site.
export const HISTORY_PLACES = [
  {
    id: "history-el-morro",
    name: "Castillo San Felipe del Morro",
    neighborhood: "Old San Juan",
    latitude: 18.4705,
    longitude: -66.1238,
    period: "16th–18th centuries",
    periodEs: "Siglos XVI–XVIII",
    summary: "This fortress guarded the entrance to San Juan Bay for centuries. Its walls tell a story of military strategy, empire, and the island's strategic place in the Caribbean.",
    summaryEs: "Esta fortaleza protegió durante siglos la entrada a la bahía de San Juan. Sus murallas cuentan una historia de estrategia militar, imperios y la importancia estratégica de la isla en el Caribe.",
    artPotential: "Esplanade monument sculptures, temporary outdoor installations",
    artPotentialEs: "Esculturas monumentales en la explanada, instalaciones temporales al aire libre",
    image: "https://upload.wikimedia.org/wikipedia/commons/9/94/FortElMorro_SanJuan_PuertoRico.jpg",
    sourceLabel: "National Park Service",
    sourceUrl: "https://www.nps.gov/saju/learn/historyculture/index.htm",
  },
  {
    id: "history-san-cristobal",
    name: "Castillo San Cristóbal",
    neighborhood: "Old San Juan",
    latitude: 18.4684,
    longitude: -66.1117,
    period: "18th century",
    periodEs: "Siglo XVIII",
    summary: "Built to defend the landward side of San Juan, San Cristóbal forms part of one of the largest Spanish fortification systems in the Americas.",
    summaryEs: "Construido para defender el lado terrestre de San Juan, San Cristóbal forma parte de uno de los sistemas de fortificación españoles más grandes de América.",
    artPotential: "Plaza bronze and stone sculptures, surrounding perimeter wall installations",
    artPotentialEs: "Esculturas en bronce y piedra en la plaza, instalaciones en la muralla perimetral",
    image: "https://upload.wikimedia.org/wikipedia/commons/5/56/Castillo_San_Cristobal_SJU_06_2019_6225.jpg",
    sourceLabel: "National Park Service",
    sourceUrl: "https://www.nps.gov/saju/learn/historyculture/index.htm",
  },
  {
    id: "history-casa-blanca",
    name: "Casa Blanca",
    neighborhood: "Old San Juan",
    latitude: 18.4662,
    longitude: -66.1197,
    period: "16th century",
    periodEs: "Siglo XVI",
    summary: "Originally built for the family of Juan Ponce de León, Casa Blanca offers a glimpse into the early colonial history of San Juan and how domestic life evolved across generations.",
    summaryEs: "Construida originalmente para la familia de Juan Ponce de León, Casa Blanca permite asomarse a la historia colonial temprana de San Juan y a cómo cambió la vida cotidiana a través de las generaciones.",
    sourceLabel: "National Park Service",
    sourceUrl: "https://www.nps.gov/saju/learn/historyculture/index.htm",
  },
  {
    id: "history-plaza-armas",
    name: "Plaza de Armas",
    neighborhood: "Old San Juan",
    latitude: 18.4664,
    longitude: -66.1129,
    period: "Historic civic center",
    periodEs: "Centro cívico histórico",
    summary: "Plazas have long been gathering points for public life in Puerto Rico. This central square, framed by the Alcaldía, connects everyday city life with San Juan's civic history.",
    summaryEs: "Las plazas han sido durante mucho tiempo puntos de encuentro para la vida pública en Puerto Rico. Esta plaza central, enmarcada por la Alcaldía, conecta la vida cotidiana con la historia cívica de San Juan.",
    artPotential: "Central square sculpture pedestals, interactive civic public art",
    artPotentialEs: "Pedestales para escultura en la plaza central, arte público cívico e interactivo",
    image: "https://www.discoverpuertorico.com/sites/default/files/listing_images/profile/8822/Plaza-de-Armas-San-Juan07869_5C3A291F-5056-A36A-082D75F557F4F13C-5c3a23095056a36_5c3a2c99-5056-a36a-08efced6ad9a1602.jpg",
    sourceLabel: "Explore the historic district",
    sourceUrl: "https://www.nps.gov/saju/index.htm",
  },
  {
    id: "history-plaza-convalecencia",
    name: "Plaza de la Convalecencia de Río Piedras",
    neighborhood: "Río Piedras",
    latitude: 18.397542,
    longitude: -66.050597,
    period: "Historic town square",
    periodEs: "Plaza histórica del pueblo",
    summary: "A historic public square of the former town of Río Piedras, documented in an early twentieth-century postcard. Its location is listed in San Juan municipal records.",
    summaryEs: "Plaza pública histórica del antiguo pueblo de Río Piedras, documentada en una postal de principios del siglo XX. Su ubicación aparece en documentos municipales de San Juan.",
    image: "/archive/rio-piedras-plaza-1920.jpg",
    sourceLabel: "Wikimedia Commons · Attilio Moscioni, c. 1920",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:San_Juan_-_Plaza_de_Rio_Piedras.jpg",
  },
  {
    id: "history-rio-piedras",
    name: "Plaza del Mercado de Río Piedras",
    neighborhood: "Río Piedras",
    latitude: 18.39903,
    longitude: -66.0483,
    period: "Community life",
    periodEs: "Vida comunitaria",
    summary: "Established in the early 20th century, the market has been the commercial and cultural heart of Río Piedras: a meeting point where food, small businesses, conversation, and neighborhood identity come together.",
    summaryEs: "Establecido a principios del siglo XX, el mercado ha sido el corazón comercial y cultural de Río Piedras: un punto de encuentro donde se unen la comida, los pequeños negocios, la conversación y la identidad del barrio.",
    artPotential: "Large-scale urban murals, street art corridors, interactive cultural sculptures",
    artPotentialEs: "Murales urbanos de gran formato, corredores de arte callejero, esculturas culturales interactivas",
    image: "/archive/rio-piedras-market-1942.jpg",
    sourceLabel: "Library of Congress · Jack Delano (1942)",
    sourceUrl: "https://www.loc.gov/pictures/item/2017797868/",
  },
  {
    id: "history-upr-rio-piedras",
    name: "Universidad de Puerto Rico, Río Piedras",
    neighborhood: "Río Piedras",
    latitude: 18.4039,
    longitude: -66.0494,
    period: "Founded 1903",
    periodEs: "Fundada en 1903",
    summary: "Founded in 1903, the campus shaped Río Piedras as an academic and cultural center, with Neo-Spanish Renaissance architecture, the landmark Tower, and a long tradition of public art and student murals.",
    summaryEs: "Fundado en 1903, el recinto convirtió a Río Piedras en un centro académico y cultural, con arquitectura neorrenacentista española, la emblemática Torre y una larga tradición de arte público y murales estudiantiles.",
    artPotential: "Mural facades, public installations, sculpture plazas, campus art integration",
    artPotentialEs: "Fachadas con murales, instalaciones públicas, plazas de esculturas, arte integrado al campus",
    image: "/archive/upr-rio-piedras-1920.jpg",
    sourceLabel: "Wikimedia Commons · Antonio Arguinzoni (c. 1920)",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Rio_Piedras_-_University_of_Puerto_Rico.jpg",
  },
  {
    id: "history-casa-ruth-hernandez",
    name: "Casa de Cultura Ruth Hernández Torres",
    neighborhood: "Río Piedras",
    latitude: 18.4031,
    longitude: -66.0482,
    period: "Community arts center",
    periodEs: "Centro de arte comunitario",
    summary: "A historic building turned municipal arts and culture center, where local urban artists and neighborhood projects find space to work and show.",
    summaryEs: "Un edificio histórico convertido en centro municipal de artes y cultura, donde artistas urbanos locales y proyectos del barrio encuentran espacio para trabajar y exponer.",
    artPotential: "Community murals, exterior mosaic walls, sculptural exhibitions",
    artPotentialEs: "Murales comunitarios, paredes de mosaico en el exterior, exhibiciones escultóricas",
    image: "https://riopiedrasestavivo.com/assets/img/bg-hero-casa-ruth.jpg",
  },
  {
    id: "history-teatro-upr",
    name: "Teatro Universidad de Puerto Rico",
    neighborhood: "Río Piedras",
    latitude: 18.4026,
    longitude: -66.0488,
    period: "1930s theater",
    periodEs: "Teatro de los años treinta",
    summary: "A 1930s theater on the UPR campus, known for decades of concerts and stage work and for housing murals by Francisco Oller and Cándido Bidó.",
    summaryEs: "Teatro de los años treinta en el campus de la UPR, conocido por décadas de conciertos y teatro y por albergar murales de Francisco Oller y Cándido Bidó.",
    artPotential: "Performance art backdrop installations, classic sculpture pedestals",
    artPotentialEs: "Instalaciones de fondo escénico, pedestales para escultura clásica",
    image: "https://www.uprrp.edu/wp-content/uploads/2015/03/TeatroHist001.jpg",
  },
  {
    id: "history-acueducto-rio-piedras",
    name: "Antiguo Acueducto de Río Piedras",
    neighborhood: "Río Piedras · El Señorial",
    latitude: 18.39,
    longitude: -66.056,
    period: "19th century",
    periodEs: "Siglo XIX",
    summary: "Built in the 1840s and 1850s, the old municipal waterworks is listed on the National Register of Historic Places and marks the edge of historic Río Piedras.",
    summaryEs: "Construido entre las décadas de 1840 y 1850, el antiguo acueducto municipal figura en el Registro Nacional de Lugares Históricos y marca el borde del viejo Río Piedras.",
    artPotential: "Heritage sculpture parks, historic brickwork environmental art, land art",
    artPotentialEs: "Parques de escultura patrimonial, arte ambiental en ladrillo histórico, land art",
    image: "https://ttqmrzjplqgaaedosasm.supabase.co/storage/v1/object/public/reservas//aarp-main-web-md.jpg",
  },
  {
    id: "history-jardin-botanico-upr",
    name: "Jardín Botánico de la UPR",
    neighborhood: "Río Piedras",
    latitude: 18.3906,
    longitude: -66.0583,
    period: "Est. 1971",
    periodEs: "Est. 1971",
    summary: "Established in 1971, the botanical garden protects native plants and continues the campus's long history of agricultural and ecological research.",
    summaryEs: "Establecido en 1971, el jardín botánico protege plantas nativas y continúa la larga historia de investigación agrícola y ecológica del campus.",
    artPotential: "Botanical sculpture trails, organic and wood installations, eco-art",
    artPotentialEs: "Senderos de escultura botánica, instalaciones orgánicas y en madera, ecoarte",
    image: "https://upload.wikimedia.org/wikipedia/commons/0/0b/University_of_Puerto_Rico_Botanical_Gardens_01.jpg",
  },
  {
    id: "history-cuartel-ballaja",
    name: "Cuartel de Ballajá",
    neighborhood: "Old San Juan",
    latitude: 18.4686,
    longitude: -66.1203,
    period: "19th century",
    periodEs: "Siglo XIX",
    summary: "A 19th-century Spanish military barracks, today home to the Museo de Las Américas and a courtyard that hosts cultural events.",
    summaryEs: "Antiguo cuartel militar español del siglo XIX, hoy sede del Museo de Las Américas y de un patio que acoge eventos culturales.",
    artPotential: "Inner courtyard sculptures, monumental installations, perimeter art",
    artPotentialEs: "Esculturas en el patio interior, instalaciones monumentales, arte perimetral",
    image: "https://upload.wikimedia.org/wikipedia/commons/e/eb/Ballaja-int.jpg",
  },
  {
    id: "history-la-fortaleza",
    name: "La Fortaleza / Palacio de Santa Catalina",
    neighborhood: "Old San Juan",
    latitude: 18.4641,
    longitude: -66.1197,
    period: "1533–1540",
    periodEs: "1533–1540",
    summary: "Built between 1533 and 1540, La Fortaleza is the official residence of the governor and the oldest executive mansion in continuous use in the New World.",
    summaryEs: "Construida entre 1533 y 1540, La Fortaleza es la residencia oficial del gobernador y la mansión ejecutiva en uso continuo más antigua del Nuevo Mundo.",
    artPotential: "Calle Fortaleza street installations, commemorative historic statues",
    artPotentialEs: "Instalaciones en la calle Fortaleza, estatuas históricas conmemorativas",
    image: "https://upload.wikimedia.org/wikipedia/commons/7/70/Palacio_de_Santa_Catalina%2C_La_Fortaleza.jpg",
  },
  {
    id: "history-quinto-centenario",
    name: "Plaza del Quinto Centenario",
    neighborhood: "Old San Juan",
    latitude: 18.4682,
    longitude: -66.1213,
    period: "Built 1992",
    periodEs: "Construida en 1992",
    summary: "Opened in 1992 for the 500th anniversary of Columbus's voyage, the plaza is anchored by Jaime Suárez's Totem Telúrico.",
    summaryEs: "Inaugurada en 1992 por el 500 aniversario del viaje de Colón, la plaza tiene como eje el Totem Telúrico de Jaime Suárez.",
    artPotential: "Monumental ceramic and stone sculptures, civic art plazas",
    artPotentialEs: "Esculturas monumentales en cerámica y piedra, plazas de arte cívico",
    image: "https://www.discoverpuertorico.com/sites/default/files/listing_images/profile/8829/Plaza-del-Quinto-Centenario-San-Juan07622_5160CF00-5056-A36A-0868F22E302FA68E-5160cac45056a36_5160d2fb-5056-a36a-0869f21bc9fc5115.jpg",
  },
  {
    id: "history-catedral-san-juan",
    name: "Catedral Metropolitana de San Juan Bautista",
    neighborhood: "Old San Juan",
    latitude: 18.4656,
    longitude: -66.118,
    period: "Est. 1521",
    periodEs: "Est. 1521",
    summary: "Founded in 1521, San Juan Bautista is one of the oldest buildings in the city and the second-oldest cathedral in the Americas.",
    summaryEs: "Fundada en 1521, San Juan Bautista es uno de los edificios más antiguos de la ciudad y la segunda catedral más antigua de América.",
    artPotential: "Religious and historical sculptural art, relief plaques",
    artPotentialEs: "Arte escultórico religioso e histórico, placas en relieve",
    image: "https://upload.wikimedia.org/wikipedia/commons/6/6f/Catedral_de_San_Juan_Bautista_a.jpg",
  },
  {
    id: "history-mapr",
    name: "Museo de Arte de Puerto Rico",
    neighborhood: "Santurce",
    latitude: 18.4486,
    longitude: -66.0655,
    period: "1920s building",
    periodEs: "Edificio de los años veinte",
    summary: "The museum occupies a restored 1920s neoclassical building, once the San Juan municipal hospital, joined to a modern wing and a historic sculpture garden.",
    summaryEs: "El museo ocupa un edificio neoclásico restaurado de los años veinte, antes hospital municipal de San Juan, unido a un ala moderna y un jardín de esculturas histórico.",
    artPotential: "Sculpture garden, outdoor museum mural backdrops",
    artPotentialEs: "Jardín de esculturas, fondos murales al aire libre del museo",
    image: "https://mapr.org/wp-content/uploads/2026/03/mapr-fachada-2000-1024x576.webp",
  },
  {
    id: "history-calle-cerra",
    name: "Calle Cerra Arts District",
    neighborhood: "Santurce · Miramar",
    latitude: 18.4502,
    longitude: -66.0827,
    period: "Street art district",
    periodEs: "Distrito de arte urbano",
    summary: "A historic commercial and industrial corridor that became the epicenter of Puerto Rico's modern street art movement through Santurce es Ley.",
    summaryEs: "Un corredor comercial e industrial histórico que se convirtió en el epicentro del movimiento de arte urbano moderno de Puerto Rico con Santurce es Ley.",
    artPotential: "Large-scale urban street murals, graffiti art, wall installations",
    artPotentialEs: "Murales urbanos de gran formato, grafiti, instalaciones en paredes",
    image: "https://www.puertoricodaytrips.com/wp-images-post/santurce-murals-1f.jpg",
  },
  {
    id: "history-placita-santurce",
    name: "Placita de Santurce (Plaza del Mercado)",
    neighborhood: "Santurce",
    latitude: 18.4508,
    longitude: -66.0712,
    period: "Built 1914",
    periodEs: "Construida en 1914",
    summary: "Built in 1914, the market sells produce by day and turns into one of San Juan's best-known nightlife and culture plazas after dark.",
    summaryEs: "Construida en 1914, la plaza vende productos frescos de día y de noche se convierte en una de las plazas de vida nocturna y cultura más conocidas de San Juan.",
    artPotential: "Mural facades, plaza sculptures, folklore art pieces",
    artPotentialEs: "Fachadas con murales, esculturas en la plaza, piezas de arte folclórico",
    image: "https://upload.wikimedia.org/wikipedia/commons/e/e1/Plaza_del_Mercado%2C_Campo_Alegre%2C_Santurce.jpg",
  },
  {
    id: "history-centro-bellas-artes",
    name: "Centro de Bellas Artes Luis A. Ferré",
    neighborhood: "Santurce",
    latitude: 18.4475,
    longitude: -66.0664,
    period: "Performing arts center",
    periodEs: "Centro de artes escénicas",
    summary: "Santurce's premier performing arts center sits in the historic cultural core of the neighborhood and stages the Caribbean's largest productions.",
    summaryEs: "El principal centro de artes escénicas de Santurce está en el núcleo cultural histórico del barrio y presenta las mayores producciones del Caribe.",
    artPotential: "Plaza sculptures, modernist monumental art, exterior wall murals",
    artPotentialEs: "Esculturas en la plaza, arte monumental modernista, murales en muros exteriores",
    image: "https://www.cba.pr.gov/images/cbafrente1.jpg",
  },
  {
    id: "history-capitolio",
    name: "Capitolio de Puerto Rico",
    neighborhood: "Puerta de Tierra",
    latitude: 18.4682,
    longitude: -66.1058,
    period: "Opened 1929",
    periodEs: "Inaugurado en 1929",
    summary: "Opened in 1929, Puerto Rico's neoclassical capitol holds the island's legislative archives, friezes and national history monuments.",
    summaryEs: "Inaugurado en 1929, el capitolio neoclásico de Puerto Rico guarda los archivos legislativos de la isla, frisos y monumentos de historia nacional.",
    artPotential: "Commemorative bronze statues, historic friezes, memorial sculptures",
    artPotentialEs: "Estatuas conmemorativas en bronce, frisos históricos, esculturas memoriales",
    image: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Capitolio_de_Puerto_Rico_%2828755163211%29.jpg",
  },
  {
    id: "history-parque-munoz-rivera",
    name: "Parque Luis Muñoz Rivera",
    neighborhood: "Puerta de Tierra",
    latitude: 18.465,
    longitude: -66.09,
    period: "Late 1920s park",
    periodEs: "Parque de finales de los veinte",
    summary: "Laid out in the late 1920s along the waterfront, its pavilions, statues and shaded walkways made it San Juan's seaside gathering place.",
    summaryEs: "Trazado a finales de los años veinte frente al mar, sus pabellones, estatuas y paseos sombreados lo volvieron el punto de encuentro junto al mar en San Juan.",
    artPotential: "Open-air sculpture paths, pavilion murals, landscape installations",
    artPotentialEs: "Senderos de escultura al aire libre, murales en pabellones, instalaciones de paisaje",
    image: "https://www.conoceapuertorico.com/wp-content/uploads/2016/05/IMG_9746-HDR.jpg",
  },
  {
    id: "history-antiguo-casino",
    name: "Antiguo Casino de Puerto Rico",
    neighborhood: "Puerta de Tierra · Old San Juan",
    latitude: 18.4667,
    longitude: -66.1119,
    period: "Completed 1917",
    periodEs: "Terminado en 1917",
    summary: "Completed in 1917, the Beaux-Arts casino was San Juan's social and cultural center before becoming a government reception hall.",
    summaryEs: "Terminado en 1917, el casino de estilo Beaux-Arts fue el centro social y cultural de San Juan antes de convertirse en salón de recepciones del gobierno.",
    artPotential: "Classical sculpture displays, architectural art lighting, plaza pieces",
    artPotentialEs: "Exhibiciones de escultura clásica, iluminación artística arquitectónica, piezas de plaza",
    image: "https://upload.wikimedia.org/wikipedia/commons/4/40/Antiguo_Casino_de_Puerto_Rico_Night.jpg",
  },
  {
    id: "history-puente-dos-hermanos",
    name: "Puente Dos Hermanos",
    neighborhood: "Condado · Miramar",
    latitude: 18.4597,
    longitude: -66.0841,
    period: "Early 20th century",
    periodEs: "Principios del siglo XX",
    summary: "Built by the Behn brothers in the early 20th century, the bridge links the islet of San Juan to Condado across the lagoon.",
    summaryEs: "Construido por los hermanos Behn a principios del siglo XX, el puente une el islote de San Juan con Condado a través de la laguna.",
    artPotential: "Waterfront kinetic sculptures, bridge entry murals, boardwalk art",
    artPotentialEs: "Esculturas cinéticas frente al agua, murales en la entrada del puente, arte en el paseo",
    image: "https://upload.wikimedia.org/wikipedia/commons/7/77/Puente_Dos_Hermanos.jpg",
  },
  {
    id: "history-plaza-de-diego",
    name: "Plaza de Diego / Stop 22 Corridor",
    neighborhood: "Santurce",
    latitude: 18.4489,
    longitude: -66.0682,
    period: "20th-century commercial core",
    periodEs: "Centro comercial del siglo XX",
    summary: "Avenida de Diego was the commercial spine of 20th-century Santurce, and the plaza and Stop 22 corridor still carry that street life.",
    summaryEs: "La avenida de Diego fue el eje comercial del Santurce del siglo XX, y la plaza y el corredor de la parada 22 todavía conservan esa vida de calle.",
    artPotential: "Urban wall murals, streetscape art, light installations",
    artPotentialEs: "Murales en muros urbanos, arte en el paisaje de calle, instalaciones de luz",
    image: "https://www.urbidermis.com/recursos/imagenes_galeria/20230124-Puerto-Rico-San-Juan-Santurce-Avenida-De-Diego-Ubarri-RAF-Equipo-Urbidermis-05-x600.jpg",
  },
  {
    id: "history-fortin-san-geronimo",
    name: "Fortín de San Gerónimo de Boquerón",
    neighborhood: "Puerta de Tierra · Condado",
    latitude: 18.4633,
    longitude: -66.0842,
    period: "18th century",
    periodEs: "Siglo XVIII",
    summary: "This small coastal fort played a crucial role defending San Juan during the British attack of 1797.",
    summaryEs: "Este pequeño fortín costero tuvo un papel clave en la defensa de San Juan durante el ataque británico de 1797.",
    artPotential: "Historical statues, oceanfront sculpture installations",
    artPotentialEs: "Estatuas históricas, instalaciones escultóricas frente al mar",
    image: "https://upload.wikimedia.org/wikipedia/commons/6/63/San_Jeronimo_aerial.jpg",
  },
  {
    id: "history-parque-central",
    name: "Parque Central de San Juan",
    neighborhood: "Hato Rey · Caño Martín Peña",
    latitude: 18.435,
    longitude: -66.075,
    period: "Urban green landmark",
    periodEs: "Pulmón verde urbano",
    summary: "A major green space along the Martín Peña canal, used for sports and recreation and part of the area's urban and environmental restoration.",
    summaryEs: "Un gran espacio verde junto al caño Martín Peña, usado para deportes y recreación y parte de la restauración urbana y ambiental de la zona.",
    artPotential: "Large environmental murals, park trail sculptures, community art",
    artPotentialEs: "Murales ambientales de gran formato, esculturas en los senderos, arte comunitario",
    image: "https://photos.zeepuertorico.com/SAN%20JUAN-Parque%20Central%20de%20San%20Juan%5EIMG_5405-BIG.jpg",
  },
  {
    id: "history-plaza-las-americas",
    name: "Plaza las Américas Public Art Walk",
    neighborhood: "Hato Rey",
    latitude: 18.4244,
    longitude: -66.0747,
    period: "Opened 1968",
    periodEs: "Inaugurado en 1968",
    summary: "Opened in 1968 as the island's premier regional hub, the mall has long been a patron of monumental Puerto Rican fine art and sculpture.",
    summaryEs: "Inaugurado en 1968 como el principal centro regional de la isla, el centro comercial ha patrocinado por décadas arte y escultura monumental puertorriqueña.",
    artPotential: "Indoor and outdoor monumental sculpture, modern mosaic murals",
    artPotentialEs: "Escultura monumental interior y exterior, murales modernos en mosaico",
    image: "https://www.discoverpuertorico.com/sites/default/files/listing_images/profile/681/plaza-pic_39BCC1FA-15A9-4AAD-AD394F873C332EFB_f6b7760b-e72d-4829-84367d3905a79c10.jpg",
  },
];